import { Dispatch, SetStateAction, useCallback, useState } from 'react'

import { isEqual } from 'lodash'

export function useSmartState<S>(
  initialState: S | (() => S)
): [S, Dispatch<SetStateAction<S>>]

export function useSmartState<S = undefined>(): [
  S | undefined,
  Dispatch<SetStateAction<S | undefined>>
]

export function useSmartState<S = undefined>(
  initialState?: S | (() => S)
): [S | undefined, Dispatch<SetStateAction<S | undefined>>] {
  const [state, setState] = useState(initialState)

  const setSmartState: typeof setState = useCallback(
    nextState => {
      if (
        typeof nextState !== 'function' &&
        (nextState === state || isEqual(nextState, state))
      ) {
        return
      }

      setState(nextState)
    },
    [state]
  )

  return [state, setSmartState]
}
